import type { Locale } from "@/i18n/locales";

import { support as en } from "./en/support";
import { support as de } from "./de/support";
import type { SupportContent } from "./types";

const SUPPORT: Readonly<Record<Locale, SupportContent>> = { en, de };

export function supportFor(locale: Locale): SupportContent {
  return SUPPORT[locale];
}
